import React from 'react'
import DKGlobalInject from './dk/global-inject'

const getInject = () => DKGlobalInject

export default getInject()
